import type { ComponentProps, ReactElement } from 'react';

import { AccountDropdown } from '../AccountDropdown/AccountDropdown';

import { StyledSalesforceActivityAccountFilter, StyledSalesforceActivitySingleAccount } from './styles';

export const AccountFilter = ({
  entities,
  defaultEntity,
  ...props
}: ComponentProps<typeof AccountDropdown>): ReactElement => {
  if (entities.length === 1) {
    return <StyledSalesforceActivitySingleAccount>{defaultEntity.name}</StyledSalesforceActivitySingleAccount>;
  }

  return (
    <StyledSalesforceActivityAccountFilter>
      <AccountDropdown defaultEntity={defaultEntity} entities={entities} {...props} />
    </StyledSalesforceActivityAccountFilter>
  );
};
